import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";

import CompanyPicker from "./CompanyPicker";

function AddCompanyInput({ existingCompaniesIds, onSubmit, onCancel }) {
  const [companyId, setCompanyId] = useState(null);

  const selectRef = useRef();

  const companyAdditionConfirmed = () => {
    if (companyId !== null) {
      onSubmit(companyId);
    }
  };

  const companyPickerKeyDown = (e) => {
    if (e.key === "Enter" && selectRef.current.state.inputIsHidden) {
      if (companyId !== null) {
        onSubmit(companyId);
      }
    } else if (e.key === "Escape") {
      onCancel();
    }
  };

  useEffect(() => {
    if (selectRef.current) {
      selectRef.current.focus();
    }
  }, []);

  return (
    <div className="col col-12">
      <Card className="p-2 d-flex flex-row h-100 align-items-center">
        <CompanyPicker
          onCompanyPicked={setCompanyId}
          onKeyDown={companyPickerKeyDown}
          companiesIdsToExclude={existingCompaniesIds}
          selectRef={selectRef}
        />
        <button type="button" className="btn btn-primary" onClick={companyAdditionConfirmed}>
          Add
        </button>
      </Card>
    </div>
  );
}

export default AddCompanyInput;
